// Helpers for Molecular Impact feature reused across modals
import type { ReactNode } from 'react';

import { PredictionToolType } from '../redux/types';

export type PredictionResultChoice = {
  label: string;
  value: string;
  order?: number;
};

export const buildPredictionResultChoices = (
  choices?: PredictionResultChoice[] | null,
): { label: string; value: string }[] => {
  if (!choices || choices.length === 0) {
    return [];
  }
  return choices
    .slice()
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((c) => ({ label: c.label, value: c.value }));
};

export const selectLabelFilterOption = (
  input: string,
  option?: { label?: ReactNode },
) =>
  String(option?.label ?? '')
    .toLowerCase()
    .includes(input.toLowerCase());

export const findToolByName = (
  tools: PredictionToolType[],
  name: string | undefined,
): PredictionToolType | undefined => {
  if (!name) {
    return undefined;
  }
  return tools.find((t) => t.name === name);
};
